import React from "react"
import { Link } from "gatsby"

import * as style from "./Resources.module.scss"

const Resource = ({ resource, microcopy }) => (
  <Link to={resource.path} className={style.link}>
    <span>{resource.title}</span>
  </Link>
)

export default Resource
